import {createAsyncThunk} from '@reduxjs/toolkit'

import {ROUTER_ORDER_POP_UP, ROUTER_ORDER_SHEET_SELLER} from '@web/core/routes'
import {openPopup} from '@web/helpers/browser'
import {orderEntryInfoSelector} from '@web/slices/common/slice'

import {NavigationActionStoreState, ThunkApi} from '../interfaces'

const POPUP_KEY = 'CHANGE_EASY_MOBILE_PIN'

/**
 * 간편결제 비밀번호 변경 페이지로 이동
 */
const navigateToEasyMobilePinChanging = createAsyncThunk<Promise<string | unknown>, void, ThunkApi>(
    'navigateTo/easyMobilePinChanging',
    async (_, {getState}) => {
        const state = getState()
        const url = getPopupUrl(state)

        return openPopup({
            key: POPUP_KEY,
            url,
            title: '간편결제 비밀변호 변경',
            size: {
                width: 500,
                height: 640,
            },
        })
    },
)

function getPopupUrl(state: NavigationActionStoreState) {
    const {isCheckout, isSellerGroup} = orderEntryInfoSelector(state)

    switch (true) {
        case isSellerGroup:
            return ROUTER_ORDER_SHEET_SELLER.POP_UP.CHANGE_MOBILE_PIN
        case isCheckout:
        default:
            return ROUTER_ORDER_POP_UP.PIN_PAY_PASS_CHANGE
    }
}
export default navigateToEasyMobilePinChanging
